import React from "react";
import { footerListHeading } from "../../constants";
import { fPsg, s1, s2, s3, s4, s5 } from "../../images/image";
import PropTypes from "prop-types";

export const FooterList = () => {
  return (
    <div className="footer-list-ct mw-ct">
      <div className="footer-list-ct">
        <div className="f-head-ct">
          {footerListHeading.map(({ id, title, list }) => {
            return (
              <div className="f-list-split" key={id}>
                <h3>{title}</h3>
                <ul>
                  {list.map(({ id, title }) => {
                    return (
                      <li className="f-list" key={id}>
                        {title}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
        {/* <div className="f-list-split"> */}
        <div className="f-list-split-last">
          <h3>ÚNETENOS</h3>
          <div className="social-icons">
            <span>
              <img src={s1} alt="facebook" />
            </span>
            <span>
              <img src={s2} alt="instagram" />
            </span>
            <span>
              <img src={s3} alt="twitter" />
            </span>
            <span>
              <img src={s4} alt="one-football" />
            </span>
            <span>
              <img src={s5} alt="F" />
            </span>
          </div>
          <div className="f-psg">
            <span>
              <img src={fPsg} alt="F" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterList.propTypes = {
  footerListHeading: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};
